module.exports = __webpack_public_path__ + "img/tariff-selection-bg--375.47ed168.jpg";